import {
  Modal,
  ModalContent,
  ModalHeader,
} from '@actovos-consulting-group/ui-core';
import React from 'react';
import LoginRegister from './login-register';

const LoginRegisterModal = ({ show, onClose, onSuccess, children }) => {
  return (
    <Modal show={show} onClose={onClose}>
      <ModalHeader>Login or Create an Account</ModalHeader>
      <ModalContent>
        {children}

        <LoginRegister onSuccess={onSuccess} />
      </ModalContent>
    </Modal>
  );
};

export default LoginRegisterModal;
